module.exports = __webpack_public_path__ + "static/media/landingCollaborator2.23e4d5e5.jpg";